import React from "react";

export const ITEM_TYPE_LABELS = {
  base: "Obbligatoria (Base)",
  optional: "Opzionale (Add-on)",
  variable: "Quantità Variabile",
};

export const ITEM_TYPE_BADGE = {
  base: "bg-slate-100 text-slate-700 border-slate-200",
  optional: "bg-indigo-50 text-indigo-700 border-indigo-200",
  variable: "bg-amber-50 text-amber-700 border-amber-200",
};



export function categoryColor(categories, name) {
  const c = (categories || []).find((x) => x.name === name);
  return c ? c.color : "#737575";
}

export function CategoryBadge({ name, categories, className = "" }) {
  if (!name) return null;
  const color = categoryColor(categories, name);
  return (
    <span
      data-testid={`category-badge-${name}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${className}`}
      style={{ backgroundColor: `${color}1a`, color, borderColor: `${color}40` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: color }} />
      {name}
    </span>
  );
}
